export default __webpack_public_path__ + "static/media/formBG.fa7fbf66.webp";